import { render } from "./AccountingDataTable.vue?vue&type=template&id=51fc78f8"
import script from "./AccountingDataTable.vue?vue&type=script&lang=js"
export * from "./AccountingDataTable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\pc\\Documents\\projets\\school_app_front_novation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__